import { z } from "zod";

const hhmmSchema = z
  .string()
  .regex(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, "Invalid time format");

export const staffRosterOverrideSchema = z
  .object({
    is_working: z.boolean(),
    start_time: hhmmSchema,
    end_time: hhmmSchema,
  })
  .refine(
    (data) => !data.is_working || data.end_time > data.start_time,
    {
      message: "End time must be after start time",
      path: ["end_time"],
    }
  );

export type StaffRosterOverrideFormValues = z.infer<
  typeof staffRosterOverrideSchema
>;
